import { useProjectsStore } from "@/stores/projects"
import { storeToRefs } from "pinia"

class AddSidebarProjectHandler {
  static apply(newProject) {
    const { projects } = storeToRefs(useProjectsStore())
    projects.value = [newProject, ...projects.value]
  }
}

export default AddSidebarProjectHandler
